import SectionHead from '../components/SectionHead';
import { blogSpot, highlightLinks, highlightVideo } from '../data/Data';
import heroBanner from '../img/highlight_1920.png';
import Card from '../UI/Card';
import Frame from '../components/Frame';
import { Link } from 'react-router-dom';

export default function Highlights() {
  return (
    <>
      <div className="hero-highlights">
        <div id="hero">
          <img
            src={heroBanner}
            id="hero-banner"
            alt="Neon sign"
            title="Custom image made by TA2, 2025"
          />
        </div>
      </div>
      <section id="container" className="resource p-flow">
        <div className="container highlight__container">
          <SectionHead
            title="Living With Aphasia"
            description="Watch the YouTube series produced by Boston University on the onset of Aphasia, its impact, and hopeful outcomes."
          />

          <div className="highlight__wrapper">
            {highlightLinks.map(({ id, title, description, path }, index) => (
              <Card className="highlights__highlight" key={id}>
                <h4>{title}</h4>
                <small>{description}</small>
                {/* Embed Frame.js for each highlight */}
                {highlightVideo[index] && (
                  <Frame
                    key={highlightVideo[index].id}
                    width="100%"
                    height="auto"
                    src={highlightVideo[index].src}
                    title={highlightVideo[index].title}
                    allow={highlightVideo[index].allow}
                    allowfullscreen={highlightVideo[index].allowfullscreen}
                    className={highlightVideo[index].className}
                  />
                )}
                <Link to={path} target="_blank" className="btn sm">
                  YouTube
                </Link>
              </Card>
            ))}
          </div>
       <SectionHead 
            title="Blog Posts" className="blog__head"
            description="Check out this Vlog from a PWA."
            />

      {Array.isArray(blogSpot) && blogSpot.map(({ title, img, content, path }) => (
        <Card className="blog__card" key={title}>
          <img src={img} alt={title} className='centered'/>
          <h3>{title}</h3>
      
          {Array.isArray(content) && content.map((text, i) =>
            text
              .split('{<br/>}')
              .map((segment, j) => (
                <p key={`${i}-${j}`}>{segment.trim()}</p>
              ))
          )}
        
          <a href={path} className="btn sm" target="_blank"       rel="noopener noreferrer">
            Go to YouTube
          </a>
        </Card>
      ))}

        </div>
      </section>
    </>
  );
}